import React from 'react';
import SEO from '../components/SEO';

function Terms() {
  // SEO structured data
  const seoStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': 'Terms of Service',
    'description': 'Pharmaceutical Database terms of service and user agreement'
  };

  return (
    <div className="page-container">
      <SEO
        title="Terms of Service - Pharmaceutical Database"
        description="Read the terms of service for using Pharmaceutical Database. Learn about user responsibilities, acceptable use, and service limitations. Updated October 23, 2025."
        keywords="terms of service, user agreement, terms and conditions, acceptable use, service terms"
        canonical="/terms"
        structuredData={seoStructuredData}
      />
      <h1 className="page-title">Terms of Service</h1>
      <p className="page-description">Last updated: October 23, 2025</p>

      <div style={{ maxWidth: '900px', margin: '0 auto', color: '#7f8c8d', lineHeight: '1.8' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>1. Acceptance of Terms</h2>
          <p>
            By accessing and using this website, you accept and agree to be bound by the terms and provision 
            of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the materials (information or software) 
            on Pharmaceutical Database for personal, non-commercial transitory viewing only. This is the grant 
            of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul style={{ marginLeft: '1.5rem' }}>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to decompile or reverse engineer any software contained on the site</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>3. Disclaimer</h2>
          <p>
            The materials on Pharmaceutical Database are provided on an 'as is' basis. Pharmaceutical Database 
            makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties 
            including, without limitation, implied warranties or conditions of merchantability, fitness for 
            a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>4. Limitations</h2>
          <p>
            In no event shall Pharmaceutical Database or its suppliers be liable for any damages (including, 
            without limitation, damages for loss of data or profit, or due to business interruption) arising 
            out of the use or inability to use the materials on Pharmaceutical Database.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>5. Accuracy of Materials</h2>
          <p>
            The materials appearing on Pharmaceutical Database could include technical, typographical, or 
            photographic errors. Pharmaceutical Database does not warrant that any of the materials on our 
            website are accurate, complete, or current. We may make changes to the materials contained on 
            our website at any time without notice.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>6. Links</h2>
          <p>
            Pharmaceutical Database has not reviewed all of the sites linked to its website and is not responsible 
            for the contents of any such linked site. The inclusion of any link does not imply endorsement by 
            Pharmaceutical Database of the site. Use of any such linked website is at the user's own risk.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>7. Modifications</h2>
          <p>
            Pharmaceutical Database may revise these terms of service for its website at any time without notice. 
            By using this website, you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '1rem' }}>8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction 
            where Pharmaceutical Database is located, and you irrevocably submit to the exclusive jurisdiction of 
            the courts in that location.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
